import defaultState from './defaultState'

const unwrapState = state => state.jobmailUnsubscribePage || {}

export const getIsUnsubscribed = state => unwrapState(state).isUnsubscribed
export const getHeaderImg = state => unwrapState(state).headerImg
export const getUserUnsubscriptionData = state => unwrapState(state) || defaultState
